export default "__VITE_ASSET__CRjdc89b__"